import LabourBreakdownTable from "@shared-containers/LabourBreakdownTable";
import { CustomCardWrapper } from "./style";

const LabourBreakdown = () => {
  return (
    <CustomCardWrapper>
      <LabourBreakdownTable pagination />
    </CustomCardWrapper>
  );
};

export default LabourBreakdown;
